import { useMemo } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Divider } from '@cbhq/cds-web/layout';
import { VStack } from '@cbhq/cds-web/layout/VStack';

import { useClientProps } from '../providers/ClientPropsProvider';
import { useProfileMenuV2 } from '../providers/ProfileMenuV2Provider';

import { UserSwitcherProfiles } from './UserSwitcher/UserSwitcherProfiles';
import { ProfileHeader } from './ProfileHeader';
import { ProfileMenuActions } from './ProfileMenuActions';
import { ThemeOverride } from './ThemeOverride';

export function ProfileDropdownContent() {
  const { profileMenuFlexibleArea = null } = useClientProps();
  const { userSwitcherEnabled } = useProfileMenuV2();
  const { isPhone } = useBreakpoints();

  const flexibleArea = useMemo(
    () => (profileMenuFlexibleArea ? [profileMenuFlexibleArea, <Divider />] : []),
    [profileMenuFlexibleArea],
  );

  if (userSwitcherEnabled) {
    return (
      <ThemeOverride>
        <VStack
          borderRadius={500}
          width={isPhone ? '100%' : '375px'}
          height="100%"
          maxHeight={isPhone ? undefined : '80vh'}
          background="bg"
        >
          <UserSwitcherProfiles />
          <ProfileMenuActions />
        </VStack>
      </ThemeOverride>
    );
  }

  return (
    <ThemeOverride>
      <VStack
        borderRadius={400}
        minWidth={isPhone ? undefined : '375px'}
        width="100%"
        height="100%"
        maxHeight={isPhone ? undefined : '80vh'}
        background="bg"
      >
        <ProfileHeader />
        <Divider />
        {flexibleArea}
        <ProfileMenuActions />
      </VStack>
    </ThemeOverride>
  );
}
